<template>
  <svg width="97" height="154" viewBox="0 0 97 154" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_498_2943)">
      <path
        d="M48.2456 129.582C52.634 130.105 70.4418 128.736 69.0236 141.529C67.6054 154.322 56.6076 154.255 48.2456 153.906C39.8835 153.557 27.3872 150.523 27.9224 142.375C28.4576 134.227 37.4618 128.307 48.2456 129.582Z"
        fill="url(#paint0_radial_498_2943)"
      />
      <path
        d="M28.9794 117.299C32.6052 116.655 62.7221 116.332 71.0841 118.131C83.9149 120.816 81.1989 129.649 80.744 133.166C79.1117 145.973 57.5041 148.349 47.871 148.013C38.2379 147.677 20.7645 144.603 17.0183 135.045C13.8608 127.018 15.8543 119.608 28.9794 117.299Z"
        fill="url(#paint1_radial_498_2943)"
      />
      <path
        d="M24.7381 102.814C29.1132 102.063 65.438 101.727 75.5795 103.781C90.9791 106.922 89.3602 116.212 88.5976 120.333C85.9217 135.26 59.1631 139.314 47.5365 138.925C35.9099 138.536 14.8241 134.898 10.3019 123.689C6.50213 114.238 8.91041 105.526 24.7381 102.814Z"
        fill="url(#paint2_linear_498_2943)"
      />
      <path
        d="M22.1026 88.8936C26.9459 88.1418 67.2444 87.8062 78.4563 89.8601C95.6353 93.0013 93.789 102.291 92.9461 106.412C89.909 121.339 60.2738 125.407 47.4564 125.004C34.639 124.601 11.1048 120.99 6.07422 109.768C1.85973 100.317 4.5356 91.6186 22.1026 88.8936Z"
        fill="url(#paint3_linear_498_2943)"
      />
      <path
        d="M19.3466 69.617C24.6181 68.8249 68.4755 68.4759 80.6774 70.6372C99.4084 73.9395 97.3614 83.6987 96.4516 88.0884C93.1335 103.741 60.8894 108.01 46.8277 107.58C32.7661 107.15 7.37216 103.365 1.9134 91.5652C-2.67571 81.6314 0.227604 72.4897 19.3466 69.617Z"
        fill="url(#paint4_linear_498_2943)"
      />
      <path
        opacity="0.3"
        d="M10.0746 96.6525C19.4401 101.874 31.709 102.989 42.185 103.74C53.5172 104.613 72.2483 101.525 77.8943 99.9951C84.477 98.2231 92.6116 95.0416 96.2775 88.7592C92.1433 103.875 60.6752 107.996 46.8276 107.58C32.8328 107.163 7.372 103.364 1.91324 91.5648C0.758801 89.2398 0.106824 86.6964 0 84.1011C2.0069 89.2559 4.93697 93.8335 10.0746 96.6525Z"
        fill="url(#paint5_linear_498_2943)"
      />
      <path
        d="M25.2467 53.1186C29.6217 52.3669 65.9331 52.0313 76.088 54.0852C91.5679 57.2264 89.9089 66.5158 89.1462 70.637C86.4704 85.5644 59.7118 89.6319 48.0718 89.2292C36.4318 88.8265 15.3727 85.202 10.8505 73.993C6.99727 64.5425 9.36541 55.8303 25.2467 53.1186Z"
        fill="url(#paint6_linear_498_2943)"
      />
      <path
        opacity="0.14"
        d="M20.4837 79.2017C28.0222 82.8555 36.1508 85.1286 44.4862 85.9137C60.2872 87.3501 78.1218 83.2289 89.0259 70.9862C85.9353 85.6184 59.5914 89.6187 48.0317 89.2294C36.472 88.8401 15.3327 85.2022 10.8105 73.9932C10.3602 72.8858 9.99352 71.746 9.71338 70.5835C12.6656 74.178 16.3342 77.1136 20.4837 79.2017Z"
        fill="url(#paint7_linear_498_2943)"
      />
      <path
        d="M28.9794 41.6142C32.6052 40.9832 62.7221 40.6476 71.0841 42.4465C83.9149 45.1312 81.1989 53.9642 80.744 57.4813C79.1117 70.2341 57.5309 72.6102 47.871 72.2746C38.2112 71.939 20.7645 68.8649 17.0183 59.3204C13.8608 51.2794 15.8543 43.8828 28.9794 41.6142Z"
        fill="url(#paint8_linear_498_2943)"
      />
      <path
        d="M48.5001 33.0094C53.5173 33.5598 74.0412 32.2174 72.4089 44.9702C70.7766 57.723 58.1332 57.723 48.5001 57.3471C38.867 56.9713 24.511 53.9509 25.1131 45.8159C25.7151 37.681 36.1242 31.7342 48.5001 33.0094Z"
        fill="url(#paint9_linear_498_2943)"
      />
      <path
        d="M48.6072 27.8278C51.7914 28.1634 64.6623 27.2909 63.6455 35.4795C62.6287 43.6681 54.668 43.6144 48.6072 43.3997C42.5463 43.1849 33.5287 41.225 33.8899 36.0299C34.2512 30.8348 40.8204 27.0224 48.6072 27.8278Z"
        fill="url(#paint10_linear_498_2943)"
      />
      <path
        d="M15.975 104.707C15.975 113.205 21.407 120.051 28.0164 120.011C28.9227 120.003 29.8235 119.867 30.6923 119.608C36.044 118.037 39.9374 111.889 39.8972 104.56C39.8571 97.23 35.8834 91.1355 30.5317 89.632C29.6639 89.3724 28.7611 89.2501 27.8558 89.2696C21.2197 89.2964 15.9215 96.2098 15.975 104.707Z"
        fill="url(#paint11_linear_498_2943)"
      />
      <path
        d="M21.2327 104.707C21.2327 112.023 25.2465 118.131 30.5982 119.634C35.95 118.064 39.8433 111.916 39.8032 104.586C39.7631 97.2567 35.7894 91.1622 30.4377 89.6587C25.1261 91.189 21.1926 97.3372 21.2327 104.707Z"
        fill="url(#paint12_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M64.8493 94.3977C76.7301 91.7934 85.4936 86.7728 89.3334 83.2423C90.5911 82.0744 92.9325 82.41 92.9726 84.1283C92.9726 86.8131 90.6045 88.6254 88.5842 90.0214C86.4165 91.4881 84.1083 92.7337 81.6938 93.7399C76.797 95.834 70.7496 96.4247 65.1303 96.4247C63.4177 96.3307 63.1769 94.7601 64.8493 94.3977Z"
        fill="url(#paint13_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M60.0063 79.3358C77.7472 73.4158 79.1119 68.4624 82.323 64.2741C83.3666 62.9317 85.7347 62.8646 86.0558 64.5426C86.2292 65.9386 86.0976 67.3558 85.6702 68.6957C85.2428 70.0356 84.5297 71.2661 83.5806 72.3016C77.667 78.4901 67.4318 81.242 60.6083 81.2152C58.869 81.2017 58.3874 79.8728 60.0063 79.3358Z"
        fill="url(#paint14_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M58.869 61.8577C71.8336 57.5351 72.837 53.8704 75.1784 50.85C75.9544 49.87 77.6804 49.8163 77.9212 51.0514C78.0444 52.0715 77.9456 53.1063 77.6314 54.0843C77.3173 55.0624 76.7953 55.9603 76.1016 56.7163C71.7801 61.2402 64.301 63.2538 59.3106 63.2403C58.1064 63.2269 57.7318 62.2604 58.869 61.8577Z"
        fill="url(#paint15_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M56.0863 47.3732C64.9434 44.4199 65.6391 41.9097 67.2312 39.8558C67.7664 39.1846 68.9438 39.1443 69.1043 39.99C69.1911 40.6886 69.1247 41.3977 68.9097 42.0678C68.6948 42.7379 68.3366 43.3529 67.8601 43.8696C64.9166 46.9571 59.8325 48.3397 56.3806 48.3129C55.5377 48.3263 55.2701 47.6551 56.0863 47.3732Z"
        fill="url(#paint16_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M62.2674 111.983C73.7067 110.184 82.3363 105.915 86.1628 102.774C87.4205 101.754 89.6281 102.197 89.5612 103.834C89.4675 106.439 87.0592 107.969 85.0657 109.204C82.945 110.471 80.7041 111.523 78.3761 112.345C73.2315 113.908 67.8284 114.429 62.4814 113.876C60.7956 113.728 60.6619 112.224 62.2674 111.983Z"
        fill="url(#paint17_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M62.8825 129.112C72.4086 127.622 79.5665 124.064 82.7642 121.46C83.8212 120.601 85.6541 120.977 85.6006 122.333C85.5203 124.507 83.5268 125.769 81.8544 126.776C80.0743 127.855 78.192 128.754 76.2351 129.461C71.957 130.785 67.4587 131.242 63.0029 130.803C61.6249 130.575 61.5446 129.327 62.8825 129.112Z"
        fill="url(#paint18_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M55.3367 142.429C63.3642 141.543 69.5053 138.844 72.2882 136.777C73.198 136.092 74.7233 136.482 74.6296 137.609C74.4824 139.435 72.7565 140.415 71.3249 141.194C69.7896 142.016 68.176 142.681 66.5084 143.18C62.876 144.105 59.0969 144.296 55.3902 143.744C54.2529 143.637 54.2128 142.563 55.3367 142.429Z"
        fill="url(#paint19_linear_498_2943)"
      />
      <path
        opacity="0.47"
        d="M4.01378 78.5573C4.3123 78.5336 4.61254 78.57 4.89686 78.6643C5.18117 78.7586 5.44384 78.909 5.66944 79.1065C5.89503 79.3041 6.079 79.545 6.21054 79.8149C6.34209 80.0848 6.41855 80.3783 6.43544 80.6783C7.1713 84.9203 7.77337 88.3166 12.0146 90.4376C13.5265 91.2162 13.3525 92.4914 11.7336 92.0484C9.15449 91.3693 6.86332 89.8717 5.20199 87.779C3.54066 85.6863 2.59822 83.1108 2.5153 80.4367C2.48339 79.9917 2.61996 79.551 2.89775 79.2026C3.17553 78.8542 3.57407 78.6238 4.01378 78.5573Z"
        fill="url(#paint20_linear_498_2943)"
      />
      <path
        d="M50.975 33.1975L50.5736 33.4392L50.2793 33.5734L49.0885 33.909H48.2991C48.2189 33.909 47.9379 33.8285 47.8844 33.8016H47.7773L47.2555 33.4929L47.1619 33.4123C47.0682 33.3318 47.0013 33.2244 46.9077 33.1438L46.7471 32.8888C46.7471 32.7814 46.6267 32.6606 46.5732 32.5532C46.5063 32.3384 46.426 32.1102 46.3591 31.882V31.7075C46.6956 29.4867 46.8433 27.2413 46.8007 24.9955C46.7108 17.2837 45.9543 9.5942 44.5396 2.01361C44.6064 1.89279 44.6733 1.75855 44.7536 1.63773V1.57061C44.7822 1.55835 44.8078 1.53999 44.8286 1.51681C44.8494 1.49363 44.8649 1.46618 44.874 1.43637V1.35583C45.0078 1.20369 45.1416 1.06945 45.2754 0.953111L45.4895 0.818871L45.9979 0.510119L46.2521 0.375879L46.4528 0.308759L46.8274 0.161095L47.3626 0.0268555H47.5767H48.1653H48.3259L48.7674 0.161095L48.9681 0.268487L49.1153 0.362455L49.2624 0.496695C51.2827 10.9674 52.7143 22.2436 51.0151 32.5263L50.975 33.1975Z"
        fill="url(#paint21_linear_498_2943)"
      />
      <g opacity="0.1">
        <path
          d="M47.4029 0H47.617H48.2993C48.6873 0.389296 49.0754 0.792015 49.4366 1.20816C49.5436 1.73169 49.6373 2.25523 49.7309 2.77877C48.9327 1.82966 48.0747 0.932889 47.1621 0.0939679L47.4029 0Z"
          fill="#683A1B"
        />
        <path
          d="M46.105 13.3032C48.6082 15.9501 50.5596 19.0718 51.8447 22.4852C51.8447 23.1833 51.8447 23.8276 51.8447 24.5659C50.5884 20.9482 48.6991 17.5843 46.2655 14.6322C46.1986 14.1892 46.1451 13.7462 46.105 13.3032Z"
          fill="#683A1B"
        />
        <path
          d="M48.2859 33.9356C48.2056 33.9356 47.9247 33.8551 47.8711 33.8282H47.7641L47.4296 33.5598C47.1159 32.7533 46.7494 31.9685 46.3325 31.2106C46.3325 30.7541 46.4529 30.2977 46.5064 29.8682C47.2687 31.1454 47.905 32.4942 48.4063 33.8954L48.2859 33.9356Z"
          fill="#683A1B"
        />
        <path
          d="M46.6938 24.3375C46.6938 23.9079 46.6938 23.465 46.6938 22.9951C48.6873 25.27 50.2677 27.8779 51.3632 30.7005C51.2829 31.2777 51.2161 31.8684 51.1224 32.4456C50.157 29.4921 48.6556 26.7432 46.6938 24.3375Z"
          fill="#683A1B"
        />
        <path
          d="M49.2362 11.746C48.163 10.4101 46.9009 9.23873 45.4899 8.26922C45.4899 7.89335 45.3963 7.5309 45.3428 7.16846C47.029 8.26323 48.5288 9.62299 49.7847 11.1957C50.3421 11.9064 50.856 12.6506 51.3233 13.424C51.3233 14.0818 51.4437 14.7664 51.5106 15.3705C50.8582 14.0988 50.0971 12.8861 49.2362 11.746Z"
          fill="#683A1B"
        />
        <path
          d="M44.7539 1.63792V1.5708H44.8208C45.8661 2.12942 46.7788 2.90784 47.4967 3.85288C48.5135 5.03419 49.4768 6.25577 50.4535 7.47736C50.5338 8.01432 50.6141 8.55127 50.681 9.08823C49.517 7.62502 48.3529 6.1618 47.1622 4.72544C46.4442 3.74496 45.5335 2.92258 44.4863 2.30912V2.05406C44.6067 1.89298 44.6736 1.75874 44.7539 1.63792Z"
          fill="#683A1B"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M45.3826 0.953208L45.4897 0.818968L45.9981 0.510216L46.2523 0.375977H46.3192C47.3981 1.14678 48.3777 2.04856 49.2359 3.06077C49.3855 3.2181 49.469 3.42723 49.469 3.64472C49.469 3.86221 49.3855 4.07134 49.2359 4.22866C49.0807 4.38197 48.8716 4.4679 48.6539 4.4679C48.4361 4.4679 48.227 4.38197 48.0719 4.22866C47.5902 3.6917 47.1086 3.14132 46.5868 2.64463C46.3444 2.39437 46.0851 2.16114 45.8108 1.94658H45.7305L45.5164 1.7855L45.1819 1.3425C45.142 1.34786 45.1015 1.34786 45.0615 1.3425L45.3826 0.953208Z"
          fill="#FFF1B6"
        />
        <path
          d="M45.8908 5.59774C46.0506 5.4534 46.2579 5.37354 46.4728 5.37354C46.6878 5.37354 46.8951 5.4534 47.0548 5.59774C48.3583 6.65458 49.5187 7.87754 50.5067 9.23564C50.5628 9.32952 50.5989 9.43407 50.6127 9.54266C50.6266 9.65125 50.6178 9.76154 50.587 9.86656C50.5273 10.0727 50.3939 10.2496 50.2124 10.3633C50.0223 10.4648 49.8012 10.4908 49.5929 10.4361C49.3846 10.3813 49.2045 10.2499 49.0885 10.0679L48.9146 9.82629L48.8209 9.70548L48.4597 9.26248C48.2099 8.96716 47.9423 8.67183 47.6569 8.3765C47.1026 7.78599 46.5128 7.23009 45.8908 6.71193C45.8131 6.63766 45.7515 6.54801 45.7101 6.44865C45.6686 6.3493 45.6482 6.24239 45.65 6.1347C45.668 5.93367 45.7528 5.74454 45.8908 5.59774Z"
          fill="#FFF1B6"
        />
        <path
          d="M46.8274 11.8398C46.9826 11.6865 47.1916 11.6006 47.4094 11.6006C47.6272 11.6006 47.8362 11.6865 47.9914 11.8398C49.3024 13.2745 50.3977 14.8935 51.2426 16.6456C51.3505 16.8348 51.3801 17.0589 51.325 17.2697C51.27 17.4806 51.1347 17.6614 50.9483 17.7732C50.7597 17.8815 50.5363 17.9111 50.3262 17.8559C50.116 17.8007 49.9359 17.665 49.8244 17.4779C49.4389 16.6445 48.9916 15.8413 48.4865 15.075C48.366 14.9005 48.2456 14.7126 48.1118 14.538L47.9245 14.2696L47.7907 14.1085C47.4898 13.7242 47.1683 13.3568 46.8274 13.0077C46.6777 12.8504 46.5942 12.6413 46.5942 12.4238C46.5942 12.2063 46.6777 11.9971 46.8274 11.8398Z"
          fill="#FFF1B6"
        />
        <path
          d="M47.4565 21.9751L47.8846 22.4986L47.9916 22.6329C47.9916 22.7134 48.1121 22.7939 48.1656 22.8879C48.4147 23.2269 48.6426 23.581 48.8479 23.9484C49.0696 24.3264 49.2706 24.7163 49.45 25.1163L49.5838 25.3982V25.5459C49.6641 25.7472 49.731 25.9486 49.7979 26.1499C49.8657 26.3557 50.0073 26.5287 50.1953 26.6354C50.3832 26.7421 50.604 26.7748 50.8147 26.7272C51.0253 26.6676 51.204 26.527 51.3117 26.3359C51.4195 26.1448 51.4476 25.9188 51.39 25.707C50.7626 23.8931 49.7953 22.2163 48.5402 20.7669C48.3806 20.6425 48.1812 20.5808 47.9795 20.5934C47.7777 20.6061 47.5875 20.6922 47.4446 20.8356C47.3017 20.979 47.2159 21.1698 47.2033 21.3722C47.1907 21.5746 47.2522 21.7747 47.3762 21.9348L47.4565 21.9751Z"
          fill="#FFF1B6"
        />
        <path
          d="M50.2795 33.5599L49.0887 33.8955C49.0451 33.8281 49.0092 33.7561 48.9817 33.6807C48.8613 33.3182 48.7409 32.9424 48.6071 32.5799C48.6071 32.4188 48.4866 32.2443 48.4197 32.0832L48.3261 31.8685V31.7476C48.0317 31.0764 47.6973 30.4052 47.336 29.7609C47.2816 29.6675 47.246 29.5642 47.2313 29.4569C47.2166 29.3497 47.2231 29.2406 47.2504 29.1359C47.2778 29.0312 47.3254 28.9329 47.3906 28.8467C47.4558 28.7604 47.5372 28.6879 47.6304 28.6333C47.7235 28.5786 47.8264 28.5429 47.9333 28.5282C48.0402 28.5134 48.1489 28.52 48.2533 28.5474C48.3576 28.5748 48.4556 28.6226 48.5415 28.688C48.6275 28.7534 48.6998 28.8352 48.7542 28.9286C49.5285 30.3087 50.1563 31.7665 50.6273 33.278C50.6407 33.3399 50.6407 33.404 50.6273 33.4659L50.2795 33.5599Z"
          fill="#FFF1B6"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_498_2943"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.4998 142.097) rotate(180) scale(29.3542 13.8426)"
      >
        <stop stop-color="#E05920" />
        <stop offset="0.62" stop-color="#F4990E" />
        <stop offset="1" stop-color="#FFBC04" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_498_2943"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(48.4998 135.954) rotate(180) scale(47.5768 10.9792)"
      >
        <stop stop-color="#E05920" />
        <stop offset="0.62" stop-color="#F4990E" />
        <stop offset="1" stop-color="#FFBC04" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_498_2943"
        x1="48.9012"
        y1="103.714"
        x2="48.9012"
        y2="146.912"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_498_2943"
        x1="48.9014"
        y1="89.793"
        x2="48.9014"
        y2="132.991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_498_2943"
        x1="48.5002"
        y1="70.5701"
        x2="48.5002"
        y2="115.983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_498_2943"
        x1="48.1521"
        y1="70.5697"
        x2="48.1521"
        y2="115.983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#481705" />
        <stop offset="0.09" stop-color="#561E04" />
        <stop offset="0.72" stop-color="#B04C01" />
        <stop offset="1" stop-color="#D35E00" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_498_2943"
        x1="49.4097"
        y1="54.0181"
        x2="49.4097"
        y2="97.2165"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_498_2943"
        x1="49.3697"
        y1="54.0183"
        x2="49.3697"
        y2="97.2167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#481705" />
        <stop offset="0.09" stop-color="#561E04" />
        <stop offset="0.72" stop-color="#B04C01" />
        <stop offset="1" stop-color="#D35E00" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_498_2943"
        x1="48.4998"
        y1="42.3122"
        x2="48.4998"
        y2="79.0805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_498_2943"
        x1="48.8078"
        y1="33.8283"
        x2="48.8078"
        y2="62.7704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_498_2943"
        x1="48.8078"
        y1="28.3514"
        x2="48.8078"
        y2="46.8765"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC04" />
        <stop offset="0.39" stop-color="#F4990E" />
        <stop offset="1" stop-color="#E05920" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_498_2943"
        x1="39.6383"
        y1="107.031"
        x2="15.7299"
        y2="107.318"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#481705" />
        <stop offset="0.09" stop-color="#561E04" />
        <stop offset="0.72" stop-color="#B04C01" />
        <stop offset="1" stop-color="#D35E00" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_498_2943"
        x1="40.6212"
        y1="104.568"
        x2="-2.28959"
        y2="116.235"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#481705" />
        <stop offset="0.09" stop-color="#561E04" />
        <stop offset="0.72" stop-color="#B04C01" />
        <stop offset="1" stop-color="#D35E00" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_498_2943"
        x1="93.5479"
        y1="87.2293"
        x2="63.211"
        y2="92.5509"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_498_2943"
        x1="85.6541"
        y1="69.674"
        x2="56.5385"
        y2="80.0838"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_498_2943"
        x1="77.1412"
        y1="55.2289"
        x2="55.8546"
        y2="62.8435"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_498_2943"
        x1="67.8986"
        y1="43.3723"
        x2="53.3595"
        y2="48.5672"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_498_2943"
        x1="89.3409"
        y1="107.051"
        x2="60.1742"
        y2="110.392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_498_2943"
        x1="85.2953"
        y1="125.075"
        x2="61.0095"
        y2="127.866"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_498_2943"
        x1="77.2189"
        y1="140.305"
        x2="56.9145"
        y2="141.808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9F19E" />
        <stop offset="0.09" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="0.25" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.46" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.72" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_498_2943"
        x1="11.8674"
        y1="84.7055"
        x2="3.39662"
        y2="86.1993"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9E77C" stop-opacity="0" />
        <stop offset="0.28" stop-color="#F9EA88" stop-opacity="0.35" />
        <stop offset="0.54" stop-color="#F9ED91" stop-opacity="0.63" />
        <stop offset="0.75" stop-color="#F9EF98" stop-opacity="0.83" />
        <stop offset="0.91" stop-color="#F9F19C" stop-opacity="0.95" />
        <stop offset="1" stop-color="#F9F19E" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_498_2943"
        x1="51.858"
        y1="16.9679"
        x2="22.9587"
        y2="16.9679"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BF7532" />
        <stop offset="0.4" stop-color="#CF894F" />
        <stop offset="0.75" stop-color="#D99561" />
        <stop offset="1" stop-color="#DD9A68" />
      </linearGradient>
      <clipPath id="clip0_498_2943">
        <rect width="97" height="154" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
